import { gql } from '@apollo/client'
import { GREFFE_FRAGMENT } from '../Fragments'

export const GREFFES_QUERY = gql`
  query getGreffes {
    greffes {
      ...GreffeFragment
    }
  }
  ${GREFFE_FRAGMENT}
`
